import { getShopConcept } from 'app/settings/state/Overview/actions'
import { useQuery } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'

interface IProps {
  conceptUUID?: string
}

export const useShopConcept = (props: IProps) => {
  const dispatch = useDispatch()
  const { data } = useQuery(['concepts', props.conceptUUID], async () => {
    if (!props.conceptUUID) {
      return null
    }
    const result = await dispatch(getShopConcept(props.conceptUUID))
    return result.Data
  })
  return data
}
